import Axios from "axios";
import { SERVER_DOMAIN, isLocalOrStagingEnv } from "src/config";

let api;

function createAxios() {
  const instance = Axios.create({
    withCredentials: true,
  });

  instance.interceptors.request.use(
    async (config) => {
      const isGatewayDomain = config.url?.includes(SERVER_DOMAIN);
      const isClientBackend = config.url?.includes('clientbackend');
      const needsAuth = isGatewayDomain || isClientBackend;
      if (!needsAuth) {
        delete config.headers.Authorization;
      } else if (isLocalOrStagingEnv()) {
        const localToken = window.sessionStorage.getItem('b2b_at_local');
        if (localToken) {
          config.headers.Authorization = `Bearer ${localToken}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      // if (error.response?.status === 401) {
      //   // TODO: Logout user
      // }
      return Promise.reject(error);
    }
  );

  return instance;
}

function getApi() {
  if (!api) {
    api = createAxios();
  }
  return api;
}

const axios = getApi();

export const plainAxios = Axios;
export default axios;
